/**
 * @author Kelnik
 *
 * ParametricResult - Вывод результата фильтрации
 */

import History from 'components/history';
import ParametricPagination from '../pagination';
import ScrollBy from 'components/scrollBy';
import tmplComplex from '../complexes/complexes.twig';
import tmplFlats from '../flats/flats.twig';
import tmplPagination from '../pagination/pagination.twig';
import Utils from 'common/scripts/utils';

class ParametricResult {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-parametric-results';
        this.container = options.wrapper ? options.wrapper.querySelector(this.containerSelector) : null;

        this.groupSelector = '.j-parametric-results-groups';
        this.tabSelector = '.j-parametric-results-tab';
        this.complexesSelector = '.j-parametric-results-complexes';
        this.flatsesSelector = '.j-parametric-results-flats';
        this.flatsWrapSelector = '.j-parametric-results-flats-wrap';
        this.titleSelector = '.j-parametric-results-title';
        this.complexItemSelector = '.j-parametric-complex';
        this.flatItemSelector = '.j-parametric-flat';

        this.sortSelector = '.j-parametric-results-sort';
        this.paginationWrapperSelector = '.j-parametric-results-pagination';

        this.offsetTop = 30;

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initPagination();
        this._initScroll();
        this._setGroup();
        this._bindEvents();
    }

    _initElements() {
        this.group = this.container.querySelector(this.groupSelector);
        this.tabs = Array.from(this.container.querySelectorAll(this.tabSelector));
        this.complexes = this.container.querySelector(this.complexesSelector);
        this.flatses = this.container.querySelector(this.flatsesSelector);
        this.flatsWrap = this.container.querySelector(this.flatsWrapSelector);
        this.title = this.container.querySelector(this.titleSelector);
        this.paginationWrapper = this.container.querySelector(this.paginationWrapperSelector);
        this.sorts = Array.from(this.container.querySelectorAll(this.sortSelector));
        this.fixFilter = document.querySelector('.j-filter-param-fix');
    }

    _initPagination() {
        this.pagination = new ParametricPagination({
            afterChange: () => {
                this.options.changePagination();
                this.anchorTopFromBottom();
            }
        });
    }

    _initScroll() {
        this.scrollBy = new ScrollBy();

        this.scrollBy.init({
            offset        : 40,
            speedAnimation: 500
        });
    }

    _bindEvents() {
        this.group.addEventListener('change', this._setGroup.bind(this));

        this.tabs.forEach((tab) => {
            tab.addEventListener('click', this._clickTab.bind(this, tab));
        });

        this.sorts.forEach((sort) => {
            sort.addEventListener('click', this._clickSort.bind(this, sort));
        });

        this._bindEventsFlatsAfterAjax();
    }

    _bindEventsFlatsAfterAjax() {
        this.electeds = Array.from(this.container.querySelectorAll('.j-parametric-flats-elected'));
        this.complexItems = Array.from(this.container.querySelectorAll(this.complexItemSelector));
        this.flatItems = Array.from(this.container.querySelectorAll(this.flatItemSelector));

        this.electeds.forEach((elected) => {
            elected.addEventListener('click', this._clickElected.bind(this, elected));
        });

        this.complexItems.forEach((complex) => {
            complex.addEventListener('mouseenter', () => {
                const id = complex.dataset.id;

                if (this.options.mouseenterComplex) {
                    this.options.mouseenterComplex(id);
                }
            });

            complex.addEventListener('mouseleave', () => {
                if (this.options.mouseleaveComplex) {
                    this.options.mouseleaveComplex();
                }
            });
        });

        this.flatItems.forEach((flat) => {
            flat.addEventListener('mouseenter', () => {
                const idComplex = flat.dataset.complexId;

                if (this.options.mouseenterFlat) {
                    this.options.mouseenterFlat(idComplex);
                }
            });

            flat.addEventListener('mouseleave', () => {
                if (this.options.mouseleaveFlat) {
                    this.options.mouseleaveFlat();
                }
            });
        });
    }

    _clickTab(tab) {
        this.checkTabByType(tab.dataset.type);
    }

    checkTabByType(type) {
        this.tabs.forEach((item) => {
            if (item.dataset.type === type) {
                item.classList.add('is-active');
            } else {
                item.classList.remove('is-active');
            }
        });

        this._setCheckedGroup(type);
        this._setGroup();
    }

    _clickSort(sort) {
        if (sort.classList.contains('is-active')) {
            sort.classList.toggle('is-desc');
        } else {
            this.sorts.forEach((item) => {
                item.classList.remove('is-active');
                item.classList.remove('is-desc');
            });

            sort.classList.add('is-active');
        }

        if (this.options.changeSorting) {
            this.options.changeSorting();
        }
    }

    _clickElected(elected) {
        event.preventDefault();

        const id = elected.dataset.id || false;
        const action = elected.classList.contains('is-active') ? 'remove' : 'add';

        elected.classList.toggle('is-active');

        if (this.options.clickElected) {
            this.options.clickElected(id, action);
        }
    }

    getSort() {
        const activeSort = this.sorts.find((item) => {
            return item.classList.contains('is-active');
        });

        return {
            type: activeSort.dataset.sort || 'price',
            turn: activeSort.classList.contains('is-desc') ? 'desc' : 'asc'
        };
    }

    _setCheckedGroup(type) {
        this.group.checked = type === 'complex';
    }

    _setGroup() {
        if (this.group.checked) {
            Utils.hide(this.flatses);
            Utils.show(this.complexes);
        } else {
            Utils.hide(this.complexes);
            Utils.show(this.flatses);
        }

        if (this.options.changeTab) {
            this.options.changeTab(this.group.checked ? 'complex' : 'flats');
        }
    }

    replaceTitle(text) {
        Utils.clearHtml(this.title);
        Utils.insetContent(this.title, text);
    }

    updatePagination(countPage) {
        Utils.clearHtml(this.paginationWrapper);
        History.remove('page');

        this.paginationWrapper.insertAdjacentHTML('beforeend', tmplPagination({countPage}));
        this._initPagination();
    }

    _scrollTop() {
        this.scrollBy.scrollToElement(this.container);
    }

    replaceFlats(data) {
        Utils.clearHtml(this.flatsWrap);
        this.flatsWrap.insertAdjacentHTML('beforeend', tmplFlats(data));

        this._bindEventsFlatsAfterAjax();
    }

    replaceComplexes(data) {
        Utils.clearHtml(this.complexes);
        this.complexes.insertAdjacentHTML('beforeend', tmplComplex(data));
    }

    showNoResult() {
        this.container.classList.add('no-result');
    }

    hideNoResult() {
        this.container.classList.remove('no-result');
    }

    anchorTopFromBottom() {
        const offsetTop = this.offsetTop + this.fixFilter.offsetHeight;

        if (this.container.getBoundingClientRect().top - offsetTop < 0) {
            this.anchorTop();
        }
    }

    anchorTop() {
        const offsetTop = this.offsetTop + this.fixFilter.offsetHeight;

        if (window.innerWidth < 960) {
            $('html,body').animate({scrollTop: $(this.container).offset().top - this.offsetTop}, 'slow');
        } else {
            $('html,body').animate({scrollTop: $(this.container).offset().top - offsetTop}, 'slow');
        }
    }
}

export default ParametricResult;
